export default __webpack_public_path__ + "e21bf28a3dc2adb1b8b0fb6e07e9b99e.png";